import { ReactNode, createContext, useEffect, useState } from "react";
import { IMaintenance } from "../../../../../types/maintenance.type";
import { getMaintenanceByLicensePlate } from "../../../../../common/services/maintenance.api";

type InitialStateType = {
  maintenances: IMaintenance[]
}

const initialState: InitialStateType = {
  maintenances: [],
}
// eslint-disable-next-line react-refresh/only-export-components
export const MaintenanceDashboardContext = createContext(initialState)

type Props = {
  children: ReactNode,
  licensePlate: string
}

export function MaintenanceReportsDashboardProvider(props: Props) {

  const [maintenances, setMaintenance] = useState<IMaintenance[]>(initialState.maintenances)

  useEffect(() => {
    async function loadLead(licensePlate: string) {
      const result = await getMaintenanceByLicensePlate(licensePlate);

      if (result.ok) {
        setMaintenance(result.data as IMaintenance[])
      }
    }

    loadLead(props.licensePlate)
  }, [props.licensePlate])

  const theState = { maintenances }

  return (
    <MaintenanceDashboardContext.Provider value={theState as InitialStateType}>
      {props.children}
    </MaintenanceDashboardContext.Provider>
  )
}